// extracted by mini-css-extract-plugin
export default {"ctn":"hundred_ctn__mnkG1","videoBox":"hundred_videoBox__B2v7D","textBox":"hundred_textBox__WL6aa","bigText":"hundred_bigText__Ufc7U"};